import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-not-logged-page',
    imports: [FontAwesomeModule],
    templateUrl: './not-logged-page.component.html',
    styleUrl: './not-logged-page.component.scss'
})
export class NotLoggedPageComponent {
  
  faTriangleExclamation=faTriangleExclamation;
  
  constructor(library: FaIconLibrary,) {
    library.addIconPacks(fas);
  }
}
